import { render, staticRenderFns } from "./returnAtm.vue?vue&type=template&id=73f081ba&scoped=true&"
import script from "./returnAtm.vue?vue&type=script&lang=js&"
export * from "./returnAtm.vue?vue&type=script&lang=js&"
import style0 from "./returnAtm.vue?vue&type=style&index=0&id=73f081ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f081ba",
  null
  
)

export default component.exports